import { createContext } from 'react';

import type { ManagerContext } from '@/features/auth/types/ManagerContext';

export const ManagerSessionContext = createContext<ManagerContext | null>(null);
